module.exports = __webpack_public_path__ + "static/media/logo12.01ee2911.png";